<!-- begin:: Page -->
<div class="m-grid m-grid--hor m-grid--root m-page m-grid-login-layout">
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin app-section-responsive-full-height"
         id="m_login">
        <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
            <div class="m-stack m-stack--hor m-stack--desktop">
                <div class="m-stack__item m-stack__item--fluid">
                    <div class="m-login__wrapper">
                        <div class="m-login__logo">
                            <a [routerLink]="'/login'">
                                <img src="../../../../assets/base/images/logos/logo_large.png" alt="Minority" class="logo">
                            </a>
                        </div>
                        <div class="m-login__signin">
                            <div class="m-login__head">
                                <h3 class="m-login__title">Iniciar Sesión</h3>
                            </div>
                            <!--begin::Form-->
                            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="m-login__form m-form">
                                <app-message></app-message>
                                <div class="form-group m-form__group">
                                    <input formControlName="email" class="form-control m-input" type="email"
                                           placeholder="Email" autocomplete="off"
                                           [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Email es obligatorio</div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group">
                                    <input formControlName="password"
                                           class="form-control m-input m-login__form-input--last"
                                           type="password"
                                           placeholder="Password"
                                           [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                        <div *ngIf="f.password.errors.required">Password es obligatorio</div>
                                    </div>
                                </div>

                                <div class="row m-login__form-sub">
                                    <div class="col m--align-left">
                                        <a href="javascript:;" id="m_login_forget_password">¿Olvidaste tu
                                            Contraseña ?</a>
                                    </div>
                                </div>

                                <!--begin::Action-->
                                <div class="m-login__form-action">
                                    <button [disabled]="loading" type="submit" id="m_login_signin_submit"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}"
                                            class="btn btn-accent m-btn m-btn--pill m-btn--custom m-btn--air">
                                        Iniciar Sesión
                                    </button>
                                </div>

                                <!--end::Action-->
                            </form>
                        </div>
                        <div class="m-login__forget-password">
                            <!--                                <app-forgot-password></app-forgot-password>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-grid-item--center app-section-responsive bg-login"
             style="background-image: url(../../../../assets/base/images/bgs/bg-5.jpg)">
            <div class="bg-kargo m-login__content">
                <div class="m-grid__item item" style=" max-width: 50%;">
                    <h3 class="m-login__welcome">Tuki</h3>
                    <!--<p class="m-login__msg">
                        Lorem ipsum dolor sit amet, coectetuer adipiscing<br>elit sed diam nonummy et nibh euismod
                    </p>-->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end:: Page -->
